export default "__VITE_ASSET__qrurMJwh__"